import * as React from 'react';
import './ProgressContainer.css';
import {Context} from '../../state/Store';
import {useTranslation} from "react-i18next";

const ProgressContainer = () => {
  const [state] = React.useContext(Context);
  const {t} = useTranslation();
  
  return (
    <>
    {state.operationId === '' &&
    <div className="progressContainer">
      <h5 className="title8">{state.defaultPromo.programType === 'STARTUP'? t('progress.startupTitle', 'Oracle for Startups') : t('progress.progressTitle')}</h5>
      <hr></hr>
      {state.nextStep &&
        <div className="progressContent">
          
          <dl>
            <dt>{t('signup.country', 'Country/Territory')}</dt>
            <dd>
              {state.countryObject.label}
            </dd>

            <dt>{t('signup.username','Username')}</dt>
            <dd>{state.username}</dd>

            <dt>{t('signup.accountName','Cloud Account Name')}</dt>
            <dd>{state.accountName}</dd>

            <dt>{t('signup.homeRegion','Home Region')}</dt>
            <dd>{state.homeRegion.label}</dd>
          </dl>
        </div>
      }
    </div>
    }
    </>
  );
}

export default ProgressContainer
